import { useState, useEffect } from 'react';
import { useApi } from '../../Services/api';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import SubTitle from '../../Components/SubTitle/SubTitle';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import DashboardHeader from '../../Components/DashboardHeader/DashboardHeader';
import Buttons from '../../Components/Buttons/Buttons';
import Popup from '../../Components/Popup/Popup';
import emailIcon from '../../Images/emailIcon.png';
import AccountTable from '../../Components/AccountTable/AccountTable';
import Initial from '../../Components/Initial/Initial';
import InviteTableImage from '../../Images/InviteTableImage.png';
import CustomSelect from '../../Components/CustomSelect/CustomSelect';
import { useGlobalState } from '../../Contexts/GlobalStateContext';
import { useClientUserState } from '../../Contexts/ClientUserStateContext';
import groupTableImage from '../../Images/groupTable.png';
import './Invite.css';

const Invite = () => {
  const [options, setOptions] = useState([{label: 'Member', value: 'Member'}]);
  const [reload, setReload] = useState(false);
  const [memberFirstName, setMemberFirstName] = useState('');
  const [memberLastName, setMemberLastName] = useState('');
  const [role, setRole] = useState('Member');
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const [validated, setValidated] = useState(false);
  const [inviteHistory, setInviteHistory] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [show, setShow] = useState(false);
  const api = useApi();

  const { clientUser } = useClientUserState();
  const { setErrorVisible, setErrorMessage } = useGlobalState();

  useEffect(() => { 
    // First, check if user is an admin, or else they cannot access this page
    if (!clientUser.IsAdmin) {
      window.location.href = '/ClientSignup/';
    } else {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { 
    // If admin, load their group members
    const getMembers = async () => {
      try {
        const raw = await api.get('Client/ClientGroupGetMembers');
        const memberData = raw.data;
        setInviteHistory(memberData.MemberList);
      } catch (error) {
        console.log('error:', error);
      }
    };
    getMembers();
  }, [reload]);

  const inviteMember = async () => {
    const newInvite = {
      pEmail: email,
      pFirstName: memberFirstName,
      pLastName: memberLastName,
    };
    try {
      const raw = await api.post('Client/InviteMember', newInvite);
      const inviteData = raw.data;
      if (!inviteData.Success) {
        setErrorVisible(true);
        setErrorMessage(inviteData.Error);
        return;
      }
      setReload(!reload);
      // reset to default
      setMemberFirstName('');
      setMemberLastName('');
      setEmail('');
    } catch (error) { 
      console.log('error:', error);
    }
  }

  const handleClose = () => setShow(false);
  const handleResendInvite = () => { 
    inviteMember();
    setShow(false);
  }
  const handleShow = () => {
    setShow(true);
  };


  const validateForm = () => {
    const newErrors = {};
    if (!memberFirstName) newErrors.memberFirstName = 'required field';
    if (!memberLastName) newErrors.memberLastName = 'required field';
    if (!role) newErrors.role = 'required field';
    if (!email) newErrors.email = 'required field';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      // Checking if email is already invited
      const emailExists = inviteHistory.some((invite) => invite.email === email);
      if (emailExists) {
        handleShow();
        return;
      }
      if (inviteHistory.some((invite) => invite.Email === email)) {
        handleShow();
        return;
      }
      
      inviteMember();
    } else {
      setValidated(true);
    }
  };

  const handleDelete = (index) => {
    const member = inviteHistory[index];
    const deleteMember = async () => {
      try {
        const body = {
          ClientSignupGroupUserId: member.ClientSignupGroupUserId
        }
        await api.post('Client/ClientGroupRemoveMember', body);
        const updatedHistory = inviteHistory.filter((_, i) => i !== index);
        setInviteHistory(updatedHistory);
      } catch (error) {
        console.log('error:', error);
      }
    }
    deleteMember();
  };

  const handleInputChange = (setter, field) => (e) => {
    setter(e.target.value);
    if (e.target.value) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: null
      }));
    }
  };

  const handleRoleSelect = (setter, field) => (e) => {
    setter(e);
    if (e) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: null
      }));
    }
  }


  const columns = [
    <img src={InviteTableImage} alt="Avatar" key="image" />,
    "Name", 
    "Email", 
    "Role", 
    "Status", 
    "Management"
  ];

  const data = inviteHistory.map((member, index) => ({
    image: <Initial firstName={member.FirstName} lastName={member.LastName} key={index} />,
    ClientSignupGroupUserId: member.ClientSignupGroupUserId,
    name: `${member.FirstName} ${member.LastName}`,
    email: member.Email,
    role: member.RoleName,
    status: member.Status,
    management: <Button className='Invite-deleteAccount' variant="link" onClick={() => handleDelete(index)}>Delete account</Button>
  }));

  if (!loaded) {
    return null;
  }

  return (
    <div className="invite-container">
      <DashboardHeader title="Invite Team Members"/>
      <SubTitle subTitle="Add New Member" />
      <div className="dashboard-form-container">
        <Form className='invite-form' noValidate validated={validated} onSubmit={handleSubmit}>
          <Row>
            <Form.Group as={Col} xs={5} controlId="firstName">
              <div className='form-group-inline'>
                <Form.Label>First Name</Form.Label>
                {errors.memberFirstName && <span className="inline-feedback text-danger">{errors.memberFirstName}</span>}
              </div>
              <Form.Control
                required
                type="text"
                placeholder="Member's first name"
                value={memberFirstName}
                onChange={handleInputChange(setMemberFirstName, 'memberFirstName')}
                className="step-inputBox"
                isInvalid={!!errors.memberFirstName}
              />
            </Form.Group>
            <Form.Group as={Col} xs={5} controlId="lastName">
              <div className='form-group-inline'>
                <Form.Label>Last Name</Form.Label>
                {errors.memberLastName && <span className="inline-feedback text-danger">{errors.memberLastName}</span>}
              </div>
              <Form.Control
                required
                type="text"
                placeholder="Member's last name"
                value={memberLastName}
                onChange={handleInputChange(setMemberLastName, 'memberLastName')}
                className="step-inputBox"
                isInvalid={!!errors.memberLastName}
              />
            </Form.Group>

            <Form.Group as={Col} xs={2} controlId="validationCustom03">
              <div className='form-group-inline'>
                <Form.Label>Role</Form.Label>
                {errors.role && <span className="inline-feedback text-danger">{errors.role}</span>}
              </div>
              <CustomSelect 
                options={options}
                placeholder={"Select Role"}
                value={role}
                onSelect={handleRoleSelect(setRole, 'role')}
                disabled
              />
                
            </Form.Group>
          </Row>

          <Form.Group controlId="validationCustom04">
            <div className='form-group-inline'>
              <Form.Label>Email</Form.Label>
              {errors.email && <span className="inline-feedback text-danger">{errors.email}</span>}
            </div>
            <Form.Control
              required
              type="email"
              placeholder="Enter email"
              value={email}
              onChange={handleInputChange(setEmail, 'email')}
              className="step-inputBox"
              isInvalid={!!errors.email}
            />
          </Form.Group>

          <div className="invite-Btn" >
            <Buttons text="Invite" />
          </div>
        </Form>
      </div>
      
      <SubTitle subTitle="Member List" />
      
      {(data.length === 0) ? 
      <div className="group-table-image-container">
        <Image className="group-table-image" src={groupTableImage}/> 
      </div> :
      <AccountTable
        data={data}
        columns={columns}
      />}

      <Popup 
        onSubmit={handleClose}
        show={show}
        handleClose={handleClose}
        title={
          <>
            <Image src={emailIcon} alt="Email Icon" className="invite-img"/>
            <h3>{`An invite has already been sent to`}</h3>
          </>
        }
        body={
          <h4 className="resend-email-text">{email}</h4>
        }
        footer={
          <Buttons back handleBack={handleClose} text="Resend Invite" handleSubmit={handleResendInvite}/>
        }
        footerStyle={"invite-popup-footer"}
      />
    </div>
  );
}

export default Invite;
